import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixed: translate({ id: 'order.form.bulk.mixed' }),
    company: translate({ id: 'orders.edit.field.company' }),
    none: translate({ id: 'global.none' }),
  }))

  return api
}
